export default "__VITE_ASSET__DlV9Zvdq__"